import React, { Component } from "react";
import { Localization } from "../common/Localization";
import LoadingPanel from "../common/LoadingPanel";
import { homeController } from "../../controllers/home.controller";

class SpravaTextDialogContent extends Component {
    state = {
        spravaText: null,
        loading: true
    };

    componentDidMount() {
        homeController.getTextSpravy(this.props.selectedSpravaId).then(response => {
            this.setState({
                spravaText: response.text,
                loading: false
            });
        });
    }

    renderDialogContent() {
        return (
            <div>
                <p>
                    <Localization messageKey={"TexFRM.Správa"} defaultMessage={"Správa"} />
                </p>
                <textarea readOnly style={{ height: "100px", resize: "none" }} className="k-textarea auto-focus" defaultValue={this.state.spravaText} />
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderDialogContent();

        return <div>{contents}</div>;
    }
}

export default SpravaTextDialogContent;



// WEBPACK FOOTER //
// ./src/components/dialogs/SpravaTextDialogContent.js